const navigation = {
  dashboard: "Dashboards",
  knowledge: "Knowledge",
  agents: "Agents",
  playground: "Playground",
  database: "Database",
  integrations: "Integrations",
  dataSources: "Data Sources",
  profile: "Profile",
  settings: "Settings",
  generalSettings: "General Settings",
  workspaceSettings: "Workspace Settings",
  selectWorkspace: "Select Workspace",
  emptyWorkspacesMessage: "Register a Workspace to see available options",
  selectOrganization: "Select organization",
  orgHint: {
    title: "You joined {{organization}}",
    message: "Switch organizations here.",
  },
  platformView: "SUPERADMIN",
  organizationView: "Organization view",
  backToOrganization: "Back to organization",
  superadminOnlyTitle: "Superadmin-only area",
  superadminOnlyDescription: "This area is only available when no organization is selected.",
  backToPlatform: "Back to Superadmin view",
  goToDashboard: "Go to Dashboard",
  account: "Account",
  logout: "Log out",
  workspaceGroup: "Workspace",
  toggleSidebar: "Toggle sidebar"
} as const;

export default navigation;
